import * as Types from 'Types';

export const getLocations = (state: Types.RootState) =>
  state.location.locations;

export const getGeoLocalizationEnabled = (state: Types.RootState) =>
  state.location.geoLocalizationEnabled;
